import{createDescendantContext as e}from"./createDescendantsContext.js";const t=e("TabPanelsDescendantsContext");export{t as TabPanelsDescendantsContext};
//# sourceMappingURL=tabPanelsDescendantsContext.js.map
